import { useRef, useState } from "react";
import { useUpdateSmsCampaigns } from "../../../../hooks/api/mutations/useMarketing";
import { pathConstants } from "../../../../routes/pathContants";
import { useNavigate, useParams } from "react-router-dom";
import { useGetSenderList } from "../../../../hooks/api/queries/usePlatformCredit";
import { cleanObject, convertToTilteCase } from "../../../../helpers";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";

const status = {
  APPROVED: "statusBlock--success",
  PENDING: "statusBlock--pending",
  SUSPENDED: "statusBlock--failed",
};

export const useSmsCampaignContentForm = ({ smsCampaign = {} }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const textareaRef = useRef();
  const [isSenderId, setIsSenderId] = useState(false);
  const [formData, setFormData] = useState({
    title: smsCampaign?.title || "",
    sender_id: smsCampaign?.sender?.id || "",
    message_body: smsCampaign?.message_body || "",
  });

  const { data, isLoading } = useGetSenderList();

  const { mutate: updateSmsCampaign, isLoading: isSubmiting } =
    useUpdateSmsCampaigns(id);
  const handleSubmitContent = () => {
    updateSmsCampaign(
      {
        data: cleanObject({ ...formData }),
        id,
      },
      {
        onSuccess: () => {
          navigate(pathConstants.MARKETING_SMS_CAMPAIGNS_SCHEDULE({ id }));
        },
      },
    );
  };

  const handleInsert = (value) => {
    setFormData((prev) => ({
      ...prev,
      message_body: formData?.message_body + " " + value,
    }));
  };

  return {
    isSubmiting,
    isSenderId,
    formData,
    senderList:
      data?.data
        ?.slice() // avoid mutating original array
        ?.sort((a, b) => {
          if (a.status === "APPROVED" && b.status !== "APPROVED") return -1;
          if (a.status !== "APPROVED" && b.status === "APPROVED") return 1;
          return 0;
        })
        ?.map((item) => ({
          ...item,
          sender_id: (
            <span className="d-flex align-items-center">
              {item.sender_id} -
              <span
                className={`${globalStyles[status?.[item.status]]} ml-1 px-2`}
                style={{ minWidth: "auto" }}
              >
                {convertToTilteCase(item.status)}
              </span>
            </span>
          ),
          isDisabled: item?.status !== "APPROVED",
        })) || [],
    isLoading,
    textareaRef,
    setFormData,
    setIsSenderId,
    handleSubmitContent,
    handleInsert,
  };
};
